import { useState, useEffect } from 'react';

/**
 * 监听窗口宽度，并判断当前屏幕宽度是否小于指定的断点。
 * @param breakpoint 屏幕宽度断点 (默认为 550px)
 * @returns boolean: 如果当前宽度小于断点，则返回 true (视为移动端视图)
 */
export const useScreenSize = (breakpoint: number = 550) => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);
    
    // 清理函数：组件卸载时移除监听器
    return () => window.removeEventListener('resize', handleResize);
  }, []); // 仅在组件挂载时执行一次

  return width < breakpoint;
};